import { render, staticRenderFns } from "./KeyboardNumerico.vue?vue&type=template&id=a04f6a54"
import script from "./KeyboardNumerico.vue?vue&type=script&lang=js"
export * from "./KeyboardNumerico.vue?vue&type=script&lang=js"
import style0 from "./KeyboardNumerico.vue?vue&type=style&index=0&id=a04f6a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports